import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { useCurrentStateAndParams } from "@uirouter/react";

import Sentry from "@similarweb/sentry-logger";

import { useToasts } from "app/common/hooks";
import { DefaultFetchService } from "app/services/fetchService";
import { useTranslation } from "pro-features/components/WithTranslation";

import { BENCHMARK_USER_API } from "../services/api";

const fetchService = DefaultFetchService.getInstance();

interface IBenchmarkResponse {
    domains: string[];
    primaryDomains: string[];
}

export const useUserdataBenchmarkQuery = () => {
    const translate = useTranslation();
    const {
        params: { key: benchmarkId },
    } = useCurrentStateAndParams<{ key: string }>();
    const { showErrorToast } = useToasts();

    return useQuery<IBenchmarkResponse | undefined>({
        queryKey: ["userdata", "benchmark", benchmarkId],
        queryFn: async () => {
            try {
                return await fetchService.get(`${BENCHMARK_USER_API}/${benchmarkId}`);
            } catch (error) {
                Sentry.errorTracker({
                    message: "Error in useUserdataBenchmarkQuery hook",
                    e: error,
                    level: "error",
                    params: {
                        extra: { benchmarkId },
                    },
                });
                const errorMessage = error instanceof Error ? error.message : "";
                showErrorToast(translate("common.api.error", { error: errorMessage }));
            }
        },
        placeholderData: keepPreviousData,
        staleTime: 5 * 60 * 1000,
    });
};
